// Seed keys for server-rendered route data.
//
// The server and the client must derive identical keys or the seed is silently
// ignored and the page refetches. Both sides import these helpers, so they
// cannot drift. Kept free of JSX so the Worker project can import it.

export type SeedMap = Record<string, unknown>;

export const HOME_KEY = "home";
export const TESTIMONIALS_KEY = "testimonials";

/** Rows per directory page. Shared so the server, the client and the canonical
    URL cannot disagree about where page 2 starts. */
export const PAGE_SIZE = 24;

export const directoryKey = (
  type: string | undefined,
  category: string | undefined,
  sort: string,
  page = 1,
) => `directory:${type ?? "all"}:${category ?? ""}:${sort}:${page}`;

/** A category's own name and blurb, so the intro copy is server-rendered
    rather than appearing after hydration. */
export const categoryMetaKey = (slug: string) => `categorymeta:${slug}`;

export const entityKey = (type: string, slug: string) => `entity:${type}/${slug}`;
export const reviewsKey = (type: string, slug: string) => `reviews:${type}/${slug}`;

// Compare ids are sorted so any permutation of the same set hits one seed entry,
// matching the sorted canonical URL.
export const compareKey = (ids: string[]) => `compare:${[...ids].sort().join(",")}`;
export const userKey = (username: string) => `user:${username}`;
